import { render, staticRenderFns } from "./tournamentDetail.vue?vue&type=template&id=32630704&scoped=true&"
import script from "./tournamentDetail.vue?vue&type=script&lang=js&"
export * from "./tournamentDetail.vue?vue&type=script&lang=js&"
import style0 from "./tournamentDetail.vue?vue&type=style&index=0&id=32630704&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32630704",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
